import { type FC } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SmsIcon from "@mui/icons-material/Sms";
import PhoneIcon from "@mui/icons-material/Phone";
import { useSnackbar } from "notistack";
import type { CustomerSummary } from "../customerSummariesApi";
import ClientDialogTitle from "./ClientDialogTitle";

interface Props {
  client: CustomerSummary | null;
  onClose: () => void;
}

const HelpdeskCard: FC<{ client: CustomerSummary }> = ({ client }) => (
  <Stack spacing={2}>
    <Box>
      <Typography variant="overline" color="text.secondary">
        Klient
      </Typography>
      <Typography variant="h6">{client.name}</Typography>
      <Typography variant="body2" color="text.secondary">
        {client.contacts[0]?.name || "Biuro"}
      </Typography>
    </Box>
    <Divider />
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <PhoneIcon fontSize="small" color="action" />
      <Typography>{client.phone ?? "—"}</Typography>
    </Stack>
    <TextField
      multiline
      minRows={3}
      fullWidth
      label="Wiadomość SMS / notatka Helpdesk"
      placeholder="Treść wiadomości (makieta)…"
      defaultValue=""
    />
    <Alert severity="info">
      Makieta: przycisk przy numerze otwiera kartę Helpdesk. Integracja SMSTravel360 / Brevo w kolejnej fazie.
    </Alert>
  </Stack>
);

const ClientHelpdeskDialog: FC<Props> = ({ client, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const sendSms = () => {
    enqueueSnackbar(`Makieta: SMS Helpdesk do ${client?.phone}`, { variant: "success" });
    onClose();
  };

  return (
    <Dialog open={Boolean(client)} onClose={onClose} maxWidth="sm" fullWidth>
      <ClientDialogTitle icon={<SupportAgentIcon color="primary" />} title="Karta Helpdesk" onClose={onClose} />
      <DialogContent dividers>{client && <HelpdeskCard client={client} />}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zamknij</Button>
        <Button variant="contained" startIcon={<SmsIcon />} onClick={sendSms}>
          Wyślij SMS
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientHelpdeskDialog;
